import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'

export default function SavingFormBuilderModal({ onSubmit }) {
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)

  const hideOverlay = () => {
    if (!loading) {
      setShow(false)
      // Reset states when modal is closed
      setTimeout(() => {
        setSuccess(false)
        setError(null)
      }, 300)
    }
  }

  const handleSubmit = async () => {
    setLoading(true)
    setError(null)

    try {
      await onSubmit()
      setSuccess(true)
      // Auto-close after success after 2 seconds
      setTimeout(() => {
        setShow(false)
        setTimeout(() => setSuccess(false), 300)
      }, 2000)
    } catch (err) {
      console.error('Error publishing form:', err)
      setError('Failed to publish form. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button className="btn-base btn-darkest-grey" onClick={() => setShow(true)}>
        save and publish
      </button>
      <Modal show={show} centered={true} onHide={hideOverlay} className="form-builder-modal">
        <div className="dome-d-flex dome-flex-column dome-gap24">
          {success ? (
            <div className="dome-d-flex dome-flex-column dome-gap12 dome-align-center">
              <div className="dome-color-dark-green dome-text-center">
                <i className="fa-solid fa-circle-check dome-h1"></i>
              </div>
              <div className="dome-h2 dome-color-dark-green dome-text-center">Successfully Published!</div>
              <div className="dome-p1-lt dome-color-darkest-grey dome-text-center">
                Your form has been successfully published.
              </div>
            </div>
          ) : (
            <>
              <div className="dome-h2 dome-color-dark-green">are you sure?</div>
              <div className="dome-p1-lt dome-color-darkest-grey">
                Publishing a form compiles all input fields + values into one file.{' '}
              </div>
              {error && (
                <div className="dome-p3 dome-color-red-alert dome-bg-light-red dome-p12 dome-rounded">
                  <i className="fa-light fa-circle-exclamation dome-mr6"></i>
                  {error}
                </div>
              )}
              <div className="dome-d-flex dome-justify-between">
                <button
                  type="button"
                  onClick={hideOverlay}
                  disabled={loading}
                  className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
                >
                  back
                </button>
                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  type="button"
                  className="dome-btn dome-btn-base dome-btn-go-green"
                >
                  {loading ? (
                    <i className="fa-duotone fa-spinner fa-spin-pulse"></i>
                  ) : (
                    'publish form'
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  )
}
